<div class="conteneur" *ngIf="config && inscriptionsActive && inscription; else loader">

  <mat-card appearance="outlined" class="info-card" *ngIf="config.infoMessage"
    [portailCustomStyle]="config.styleCardInfo">
    <div [innerHtml]="config.infoMessage | safe"></div>
  </mat-card>

  <mat-card appearance="raised" *ngIf="options; else loader"
    [ngClass]="{'form-container': !isMobile, 'form-container-mobile': isMobile}">
    <mat-card-header class="fx-direction-row fx-center-center">
      <mat-card-title class="fx-direction-row fx-center-center">
        <span *ngIf="!isEdit">{{ 'cogito.new_inscription'|trans }}</span>
        <span *ngIf="isEdit">{{ inscription.prenom }} {{ inscription.nom }}</span>
      </mat-card-title>
      <mat-card-subtitle *ngIf="isEdit">
        Année scolaire : {{inscription.anneeScolaire.designation}}
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

      <p>
        <mat-checkbox [(ngModel)]="inscription.isRedoublement" [disabled]="!inscription.editable"
          style="text-align: start;">
          Redoublement
        </mat-checkbox>
      </p>

      <ng-container *ngIf="!isEdit">
        <p>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Enfant</mat-label>
            <mat-select [(ngModel)]="inscription.idEnfant" (ngModelChange)="childChanged($event)"
              [disabled]="fromDemarche && usager" required>
              <mat-option *ngFor="let child of options.childList" [value]="child.id">
                {{ child.prenom }} {{ child.nom }}
                <span *ngIf="child.age && inscription.anneeScolaire">({{ child.age.years + ' ans au ' +
                  setDisplayDateToCalculate(dateToCalculate) }})</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>

        <p>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Année scolaire</mat-label>
            <mat-select [(ngModel)]="inscription.anneeScolaire"
              [disabled]="!config.enabledSelectAnneeScolaire || !inscription.editable || !inscription.idEnfant"
              (ngModelChange)=" anneeScolaireChanged($event)" [compareWith]="compareAnneeFn" required>
              <mat-option *ngFor="let anneeScolaire of config.listAnneesScolaires" [value]="anneeScolaire">
                {{ anneeScolaire.designation }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
      </ng-container>

      <p>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Niveau scolaire</mat-label>
          <mat-select [(ngModel)]="inscription.niveauScolaire" (ngModelChange)=" niveauScolaireChanged($event)"
            [disabled]="!config.enabledSelectNiveauScolaire || !inscription.idEnfant || !inscription.anneeScolaire || !inscription.editable"
            required>
            <mat-option *ngFor="let niveauScolaire of listNiveauxScolairesAvailable"
              [value]="niveauScolaire.idNiveauScolaire">
              {{ niveauScolaire.designation }}
            </mat-option>
          </mat-select>
          <mat-hint
            *ngIf="config.enabledSelectNiveauScolaire && inscription.idEnfant && inscription.anneeScolaire && config.limitSelectNiveauScolaire !== 'NoLimit'">
            <mat-icon color="primary" style="margin-right: 5px;">info</mat-icon>
            <span>{{ 'cogito.edit.message_niveau_scolaire'|trans }}</span>
          </mat-hint>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field
          *ngIf="demandeDerogation && config.enabledDerogationObligatoire && libelleSecteurScolaireOrigine"
          subscriptSizing="dynamic">
          <mat-label>Secteur scolaire d'origine</mat-label>
          <input matInput [value]="libelleSecteurScolaireOrigine" readonly disabled>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field *ngIf="demandeDerogation" subscriptSizing="dynamic">
          <mat-label>Motif de dérogation</mat-label>
          <mat-select [(ngModel)]="inscription.idMotifDerogation" required>
            <mat-option *ngFor="let motif of config.listMotifsDerogation" [value]="motif.idMotifDerogation">
              {{ motif.motif }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{demandeDerogation ? 'Secteur scolaire de destination' : 'Secteur scolaire'}}</mat-label>
          <mat-select [(ngModel)]="inscription.secteurScolaire" (ngModelChange)="secteurScolaireChanged($event)"
            [disabled]="!inscription.idEnfant || !inscription.editable || !inscription.niveauScolaire || (config.enabledDerogationObligatoire && !inscription.idMotifDerogation)"
            required>
            <mat-option *ngFor="let secteurScolaire of listSecteursScolaireAvailable"
              [value]="secteurScolaire.idSecteurScolaire">
              {{ secteurScolaire.libelle }}
            </mat-option>
          </mat-select>
          <mat-hint
            *ngIf="config.enabledDerogationObligatoire && inscription.niveauScolaire && !isEdit && !demandeDerogation">
            <mat-icon color="primary" style="margin-right: 5px;">info</mat-icon>
            <span>{{ 'cogito.edit.message_derogation_secteur_scolaire'|trans }}</span>
          </mat-hint>
        </mat-form-field>
      </p>

      <p>
        <button *ngIf="config.enabledDerogationObligatoire && !isEdit" mat-raised-button
          [color]="demandeDerogation ? 'warn': 'accent'"
          [disabled]="!inscription.idEnfant || !inscription.niveauScolaire" (click)="onClickDemandeDerogation()">
          {{demandeDerogation ? 'Supprimer la demande de dérogation' : 'Demande de dérogation'}}</button>
      </p>
      <p>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>École</mat-label>
          <mat-select [(ngModel)]="inscription.ecole" (ngModelChange)="ecoleChanged($event)"
            [disabled]="!inscription.idEnfant || !inscription.secteurScolaire || !inscription.niveauScolaire || !inscription.editable"
            required>
            <mat-option *ngFor="let ecole of listEcolesAvailable" [value]="ecole.idEcole">
              {{ ecole.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Classe</mat-label>
          <mat-select [(ngModel)]="inscription.classe"
            [disabled]="!inscription.idEnfant || !inscription.secteurScolaire || !inscription.niveauScolaire || !inscription.ecole || !inscription.editable"
            required>
            <mat-option *ngFor="let classe of listClassesAvailable" [value]="classe.idClasseScolaire">
              {{ classe.libelleClasse }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </p>

      <app-params-libre *ngFor="let paramLibre of paramsLibres" class="params-libres-component"
        [paramLibre]="paramLibre" [ngStyle]="{'width': !isMobile ? '80%' : '100%'}">
      </app-params-libre>
    </mat-card-content>

    <mat-card-actions class="fx-center-center">
      <button mat-raised-button color="primary" (click)="onClickValidateInscription()"
        [disabled]="saving || !inscription.idEnfant || !inscription.classe || !checkParamsLibres() || !inscription.editable">
        <div class="fx-direction-row fx-start-center">
          <span>Valider</span>
          <mat-progress-spinner *ngIf="saving" mode="indeterminate" strokeWidth="2" diameter="18"
            style="margin-left: 5px;"></mat-progress-spinner>
        </div>
      </button>
    </mat-card-actions>

  </mat-card>
</div>

<ng-template #loader>
  <app-loader class="margin" *ngIf="!config || !inscription">
    <h3>Chargement</h3>
  </app-loader>
  <h3 *ngIf="!inscriptionsActive && config && inscription" style="text-align: center;">
    {{ 'cogito.inscription_disabled'|trans }}</h3>
</ng-template>